// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import { RootState } from 'client/core/store';

export const isInvitingNewMember = (state: RootState): boolean => {
    const members = state.project.members.list.data;

    return members.length > 0 && members[0].id === 0;
};
